import React from "react";
import { Stepper } from "./Stepper";

export const Header = ({ currentStep = 1 }) => {
  return (
    <header
      data-testid="app-header"
      className="fixed top-0 left-0 w-full z-50 bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-white/10"
    >
      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6">
        {/* Logo row */}
        <div className="flex items-center justify-between h-16">
          <div data-testid="app-logo" className="flex items-center gap-2.5">
            <span className="inline-block h-6 w-6 rounded-md bg-[#F5C518] rotate-12" />
            <span className="font-heading text-lg font-bold tracking-tight text-white">
              REC Ventures
            </span>
          </div>
          <span className="hidden sm:inline font-body text-xs uppercase tracking-[0.2em] text-zinc-500">
            Client Onboarding
          </span>
        </div>

        {/* Stepper row */}
        <div className="pb-4 pt-1">
          <Stepper currentStep={currentStep} />
        </div>
      </div>
    </header>
  );
};
